"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FunctionNodeDependencies = void 0;
var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");
var _dependenciesSymbolNodeGenerated = require("./dependenciesSymbolNode.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var FunctionNodeDependencies = exports.FunctionNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  SymbolNodeDependencies: _dependenciesSymbolNodeGenerated.SymbolNodeDependencies,
  createFunctionNode: _factoriesAny.createFunctionNode
};